/**
 * Bulk Import — step 3: in-progress loader while /execute runs.
 */

import { useTranslation } from 'react-i18next';
import { Button } from '../../../components/button';
import bulk from './bulk-import.module.css';

interface Props {
  onOpenHistory: () => void;
}

export function BulkImportSubmitting({ onOpenHistory }: Props) {
  const { t } = useTranslation();

  return (
    <div className={bulk.bulkImportSubmitting}>
      <div className={bulk.bulkImportSubmittingIcon}>⏳</div>
      <h3>{t('admin.bulkImport.submitting.title')}</h3>
      <p className={bulk.bulkImportSubmittingHint}>{t('admin.bulkImport.submitting.body')}</p>
      <p className={bulk.bulkImportSubmittingHint}>{t('admin.bulkImport.submitting.openHistoryHint')}</p>
      <Button type="button" variant="gold" onClick={onOpenHistory}>
        {t('admin.bulkImport.openHistory')}
      </Button>
    </div>
  );
}
